import {
    useRef,
    useState
} from 'react';

import { SimpleGrid, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

import { useSubscriptionItems } from '../hooks/useSubscriptionItems.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableColumn } from "mantine-datatable";
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { SubscriptionItem } from '../types';

interface RecordsTableProps {
    subscriptionId?: string;
}

export const RecordsTable = ({ subscriptionId }: RecordsTableProps) => {

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useSubscriptionItems(subscriptionId || '');

    const [selectedRecords, setSelectedRecords] = useState<SubscriptionItem[]>([]);



    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const columns: DataTableColumn<SubscriptionItem>[] = [
        {
            accessor: 'id',
            title: 'Subscription Item',
            render: (record: SubscriptionItem) => (
                <Link to={`/subscription-items/${record.id}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.id}
                    </Text>
                </Link>
            )
        },
        { accessor: 'created', title: 'Created' },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};